module.exports = __webpack_public_path__ + "img/floor_UG1.1d96fdf3.svg";